import {
	modifySelectValueToBasic,
	selectGetValueTransformer,
	selectSetValueTransformer,
	transformSelectGetOptionsVisibility,
	transformSelectSetOptionsVisibility,
	type SelectInternalValue,
	type SelectOption,
} from './select';

export type RadioButtonsSetPublicValue = string | null;

export const radioButtonsSetValueTransformer = selectSetValueTransformer;
export const radioButtonsGetValueTransformer = selectGetValueTransformer;
export const radioButtonsSetOptionsVisibilityTransformer = transformSelectSetOptionsVisibility;
export const radioButtonsGetOptionsVisibilityTransformer = transformSelectGetOptionsVisibility;
export const modifyRadioButtonsValueToBasic = modifySelectValueToBasic;

export const radioButtonsValueToSelectedOptionTransformer = (
	value: unknown,
	allowedValues: SelectOption[] | undefined,
): SelectInternalValue => {
	if (value === null) {
		return null;
	}

	if (typeof value !== 'string' || !allowedValues) {
		return null;
	}

	return radioButtonsSetValueTransformer(value, allowedValues) ?? null;
};

export const normalizeRadioButtonsValue = (
	value: SelectInternalValue | string | undefined,
): string => {
	if (!value) {
		return '';
	}

	return typeof value === 'string' ? value : value.value;
};
